import { render, staticRenderFns } from "./SerialHeader.vue?vue&type=template&id=3c53008c&scoped=true&"
import script from "./SerialHeader.vue?vue&type=script&lang=js&"
export * from "./SerialHeader.vue?vue&type=script&lang=js&"
import style0 from "./SerialHeader.vue?vue&type=style&index=0&id=3c53008c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c53008c",
  null
  
)

export default component.exports